<template>
  <div class="card flex-grow-1 mb-4">
    <div class="card-header d-flex py-1">
      <strong class="pt-1">Resource Links</strong>
      <button class="btn btn-link ml-auto py-0" type="button" data-toggle="collapse" data-target="#resource-links"><i class="fas fa-chevron-circle-up"></i></button>
    </div>
    <div id="resource-links" class="card-body collapse">
      <div class="row">
        <div class="col-md-5">Resource URL</div>
        <div class="col-md-5">Resource Label</div>
      </div>
      <div v-for="(resource, index) in resourceLinks" :key="index" class="row mb-2">
        <div class="col-md-5">
          <input type="text" v-model="resource.url" class="w-100 form-control">
        </div>
        <div class="col-md-5">
          <input type="text" v-model="resource.label" class="w-100 form-control">
        </div>
        <div class="col-md-2">
          <button type="button" v-on:click.prevent="removeResourceLink(index)" class="btn btn-danger">Remove</button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button type="button" v-on:click.prevent="addResourceLink()" class="btn btn-primary">Add Resource</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    props: ['resources'],
    data() {
      return {
        resourceLinks: []
      }
    },
    methods: {
      addResourceLink: function() {
        this.resourceLinks.push({url: '', label: ''})
      },
      removeResourceLink: function(index) {
        this.resourceLinks.splice(index, 1)
      },
      getResources: function() {
        return this.resourceLinks
      }
    },
    mounted() {
      //init resources
      this.resourceLinks = this.resources
    }
  }
</script>